<!--
  This is for finding a restaurant via places api search
  selected restaurant is checked against our internal database
  options are then given to add if not there or use if it is.

-->

<script setup>
import { displayPhone } from '@/plugins/misc'
import { ref } from 'vue'
import restaurntPin1 from '@/assets/images/maps/restaurant-waiter-icon.svg'
import {useReservationsStore, useRestaurantsStore, useUsersStore} from "@/stores"
import {
  emailValidator,
  requiredValidator,
} from '@validators'
import axios from "@axios"

const props = defineProps({
  confirmationMsg: {
    type: String,
    required: true
  },
  isDialogVisible: {
    type: Boolean,
    required: true
  }
})

const emit = defineEmits([
  'update:isDialogVisible',
  'confirm',
  'cancel'
])


const usersStore = useUsersStore()
let myUser = null;
({ myUser } = storeToRefs(usersStore))

const restaurantsStore = useRestaurantsStore()
let restaurants = null
let markets = [];
({ restaurants, markets } = storeToRefs(restaurantsStore))
restaurantsStore.getRestaurants()


const reservationsStore = useReservationsStore()

const updateModelValue = val => {
  emit('update:isDialogVisible', val)
}

// Map Stuff
const center = ref({
  lat: 14.5069174,
  lng: 121.0409052,
})

const markers = ref([])

const selectedPlace = ref()

const selectedMarketToLink = ref()
const selectedRestaurantToLink = ref()

const show = ref(false)
const showAdminAdder = ref(false)

const input = ref()
const inputValue = ref("")

function clearSelection() {
  selectedPlace.value = null
  inputValue.value = null // Clear the value of the input
}

// Helper function to get photo URL from photo reference
const getPhotoUrl = (photoReference, maxWidth = 400, maxHeight = 400) => {
  const apiKey = import.meta.env.VITE_APP_GOOGLE_MAPS_API_KEY
  
  return `https://d128sk95sboo22.cloudfront.net/maps/api/place/photo?maxwidth=${maxWidth}&maxheight=${maxHeight}&photo_reference=${photoReference}&key=${apiKey}`
}

const setPlace = async place => {
  console.log("setPlace", place)

  // navigator.geolocation.getCurrentPosition(position => {
  //   center.value = {
  //     lat: place.geometry.location.lat(),
  //     lng: place.geometry.location.lng(),
  //   };
  // });

  if(place.geometry){
    center.value = {
      lat: place.geometry.location.lat,
      lng: place.geometry.location.lng,
    }

    markers.value = [
      {
        position: {
          lat: place.geometry.location.lat,
          lng: place.geometry.location.lng,
        },
        icon: place.icon
      },
    ]
  }

  //make call to google timezone api and append timezone to place object
  const timeZone = await axios.get(`https://d128sk95sboo22.cloudfront.net/maps/api/timezone/json?location=${place.geometry.location.lat},${place.geometry.location.lng}&key=${import.meta.env.VITE_APP_GOOGLE_MAPS_API_KEY}`)
  place.timeZone = timeZone.data

  // Convert photo objects to plain objects with photo references
  if (place.photos && place.photos.length > 0) {
    place.photos = place.photos.map(photo => ({
      photo_reference: photo.photo_reference,
      height: photo.height,
      width: photo.width,
      html_attributions: photo.html_attributions,
      getUrl: (options = {}) => {
        const maxWidth = options.maxWidth || 400
        const maxHeight = options.maxHeight || 400
        
        return getPhotoUrl(photo.photo_reference, maxWidth, maxHeight)
      }
    }))
  }

  selectedPlace.value = place
}

const openInfoWindow = marker => {
  console.log("openInfoWindow", marker)
}

const restaurantsForSelectedCity = computed(() => {
  let returnArray = []
  restaurants.value.forEach(function (restaurant) {
    if (restaurant.market == selectedMarketToLink.value) {
      if (restaurant.status == "Member Favorite") {
        returnArray.push({text: restaurant.name + "*", value: restaurant.name, status: restaurant.status, id: restaurant._id})
      }
      if (restaurant.status == "Preferred") {
        returnArray.push({text: restaurant.name, value: restaurant.name, status: restaurant.status, id: restaurant._id})
      }

    }
  })
  
  return returnArray
})

const restaurantLinkedToSelectedPlace = computed(() => {
  return restaurants.value.find( restaurant => restaurant.googlePlaceId == selectedPlace.value.place_id)

})

const missingData = computed(() => {
  if (selectedPlace.value && selectedPlace.value.website && selectedPlace.value.website.length > 0) {
    return false
  }
  
  return true

})

const limitPreferredRestaurant = () => {
  if (selectedRestaurantToLink.value.length > 1) {
    nextTick(() => selectedRestaurantToLink.value = selectedRestaurantToLink.value.slice(0, 1))
  }

  //else if editingReservation.value.alternateRestaurants[0] is not in restaurantsForSelectedCity
  else if (selectedRestaurantToLink.value.length == 1 && !restaurantsForSelectedCity.value.map(x => x.value).includes(selectedRestaurantToLink.value[0])) {
    nextTick(() => selectedRestaurantToLink.value = [])
  }
}

const addAndFavorite = async  () => {
  await restaurantsStore.newRestaurantFromGooglePlace(selectedPlace.value, myUser.value.email)
  restaurantsStore.favoriteRestaurant(restaurantLinkedToSelectedPlace.value._id, myUser.value._id)
  clearSelection()
}
</script>

<template>
  <div>
    <div>
      <!--    https://developers.google.com/maps/documentation/javascript/reference/places-autocomplete-service#ComponentRestrictions -->
      <GMapAutocomplete
        :input-ref="input"
        placeholder="Search by name and location"
        :options="(myUser?.userLevel == 'admin' ? {} : {
          types: [`restaurant`, 'bar', 'cafe', 'food']
        })"
        @place_changed="setPlace"
      >
        <template #input="slotProps">
          <VTextField
            v-bind="slotProps"
            ref="input"
            :model-value="inputValue"
            prepend-inner-icon="mdi-map-marker"
            hide-details
            clear-icon="mdi-close-circle"
            clearable
            :persistent-clear="true"
            @click:clear="selectedPlace = null"
          />
        </template>
      </GMapAutocomplete>
    </div>

    <VCard
      v-if="selectedPlace"
      class="mx-auto mt-4"
      max-width="800"
    >
      <!--        <v-img -->
      <!--          :src="selectedPlace.photos[0].getUrl()" -->
      <!--          height="200px" -->
      <!--          cover -->
      <!--        ></v-img> -->
      <VCarousel
        height="200px"
        hide-delimiters
        show-arrows="hover"
      >
        <VCarouselItem
          v-for="(photo, index) in selectedPlace.photos"
          :key="index"
          :src="photo.getUrl()"
          cover
        />
      </VCarousel>



      <VCardTitle>
        <a
          :href="selectedPlace.website"
          target="_blank"
        >{{ selectedPlace.name }}</a>
      </VCardTitle>

      <VCardSubtitle>
        {{ selectedPlace.vicinity }}<br>
        {{ displayPhone(selectedPlace.formatted_phone_number) }}<br>
        <!--      <a :href="selectedPlace.website" _target="blank">{{selectedPlace.website}}</a> -->
      </VCardSubtitle>


      <VCardSubtitle v-if="restaurantLinkedToSelectedPlace">
        <span />
        {{ restaurantLinkedToSelectedPlace.status }} Restaurant
      </VCardSubtitle>
      <div v-if="missingData">
        <VAlert
          class="ma-4 text-caption"
          type="info"
        >
          We're missing some information on this restaurant. After we review Platinum members will be able to request.
        </VAlert>
      </div>
      <VDivider class="ma-4" />
      <VCardActions>
        <template
          v-if="restaurantLinkedToSelectedPlace"
        >
          <VSpacer />
          <VBtn
            color="orange-lighten-2"
            variant="text"
            @click="restaurantsStore.favoriteRestaurant(restaurantLinkedToSelectedPlace._id, myUser._id); selectedPlace = null;"
          >
            <VIcon
              size="20"
              class="mr-1"
              icon="mdi-heart-outline"
            />Add to Favorites
          </VBtn>
          <VSpacer />
        </template>
        <template v-else>
          <VSpacer />
          <VBtn
            color="orange-lighten-2"
            variant="text"
            @click="addAndFavorite"
          >
            <VIcon
              size="20"
              class="mr-1"
              icon="mdi-heart-outline"
            /> Add to Favorites
          </VBtn>
          <VSpacer />
        </template>
      </VCardActions>
    </VCard>
    <VRow class="mt-4">
      <VCol />
      <VCol />
    </VRow>
  </div>
</template>

<style scoped>
.dialog-close-btn {
  position: fixed;
  right: 6px;
  top: 6px;
}
</style>
